import './index.scss'
import MatchRoad from '@Components/MatchComponents/MatchRoad'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import Button from '@Components/Buttons/Button'
import Popup from '@Components/Popups/Popup'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface SubmitMatchPopupProps {
    isLoading: boolean
    onCancel: () => void
    onConfirm: () => void
}

const SubmitMatchPopup = (props: SubmitMatchPopupProps) => {
    const { isLoading, onCancel, onConfirm } = props
    const { userStore } = useContext(StoresContext)
    return (
        <Popup onClose={onCancel}>
            <div className="modal-content submit-match-popup">
                <h2>Are you sure you want to match to this work?</h2>
                <p>
                    Once submitted, you can&apos;t edit or cancel this match while it&apos;s under review. Reviews may
                    take over a month.
                </p>
                <p>
                    Review the work details for the selected recordings and confirm they are a match to your work before
                    continuing
                </p>
                <MatchRoad step={2} />
                {isLoading ? (
                    <PointPreloader />
                ) : (
                    <div className="button-row">
                        <Button mainColor type="secondary" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button mainColor type="primary" disabled={userStore.isActionDisabled} onClick={onConfirm}>
                            Confirm
                        </Button>
                    </div>
                )}
            </div>
        </Popup>
    )
}

export default observer(SubmitMatchPopup)
